import './creditCardImage.scss';

export const CreditCardImage = angular
    .module('checkout.components.creditCardImage', [])
    .component('creditCardImage', {
        template: `
            <img ng-src="{{$ctrl.imageUrl}}" class="credit-card-image" />
        `,
        bindings: {
            cardType: '<'
        },
        controller: class CreditCardImageCtrl {
            $onChanges(changesObj) {
                if (changesObj.cardType) {
                    const urlBase = '//d3dl6qv39aj0xv.cloudfront.net/assets/payment';
                    const imageFileName = this.getFileNameFromCardType(changesObj.cardType.currentValue);
                    this.imageUrl = `${urlBase}/${imageFileName}`;
                }
            }

            getFileNameFromCardType(cardType) {
                switch (angular.isString(cardType) ? cardType.toUpperCase() : cardType) {
                    case 'AMEX':
                    case 'AMERICAN EXPRESS':
                        return 'cc_amex.svg';
                    case 'VISA':
                        return 'cc_visa.svg';
                    case 'MC':
                    case 'MASTERCARD':
                        return 'cc_mastercard.svg';
                    case 'DISC':
                    case 'DISCOVER':
                        return 'cc_discover.svg';
                    default:
                        return 'cc_default.png';
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/creditCardImage/creditCardImage.js